export enum GasSpeed {
	Rapid = 'rapid',
	Fast = 'fast',
	Standard = 'standard',
	Slow = 'slow'
}
